import { TOKEN_IProjectBus, type IProjectBus } from "@/services/ProjectBus";
import { makeAutoObservable } from "mobx";
import { inject, injectable } from "tsyringe";

export const AvailableModalDialogs = {
    CreateShareLink: 0,
    ViewAccessList: 1,
    ShareLinksList: 2,
    MyProjects: 3,
} as const;

// Create a type from the values of the const object
export type AvailableModalDialogs = typeof AvailableModalDialogs[keyof typeof AvailableModalDialogs];

export const TOKEN_ModalDialogStore = Symbol("ModalDialogStore");

@injectable()
export class ModalDialogStore {
    constructor(
        @inject(TOKEN_IProjectBus) private projectBus: IProjectBus
    ) {
        makeAutoObservable(this);

        projectBus.subscribe_projectLoaded(this.onProjectLoaded);
    }

    private onProjectLoaded = async (): Promise<void> => {
        this._isOpen = false;
    }

    private _currentDialog: AvailableModalDialogs | undefined = undefined;
    public get currentDialog(): AvailableModalDialogs | undefined {
        return this._currentDialog;
    }

    private _isOpen: boolean = false;
    get isOpen(): boolean {
        return this._isOpen;
    }

    private _dialogTitle: string = "";
    get dialogTitle(): string {
        return this._dialogTitle;
    }

    private _dialogDescription?: string;
    get dialogDescription(): string | undefined {
        return this._dialogDescription;
    }

    onOpenChange = (open: boolean) => {
        this._isOpen = open;
        if (!open) {
            this._currentDialog = undefined;
        }
        this.projectBus.dialogStateChanged(this._isOpen, this._dialogTitle, this._dialogDescription);
    };

    onClose = () => {
        this._isOpen = false;
        this._currentDialog = undefined;
        this.projectBus.dialogStateChanged(this._isOpen, this._dialogTitle, this._dialogDescription);
    };

    openDialog = (dialogToOpen: AvailableModalDialogs, title: string, dialogDescription?: string) => {
        this._dialogTitle = title;
        this._dialogDescription = dialogDescription;
        this._isOpen = true;
        this._currentDialog = dialogToOpen;
        this.projectBus.dialogStateChanged(this._isOpen, this._dialogTitle, this._dialogDescription);
    }
}